import { takeLatest, call, put, all, delay, select } from "redux-saga/effects";
import authProvider, { createEndSessionRequest } from "../authProvider";
import {
  LOGOUT,
  LOGOUT_SUCCESS,
} from "../../common/redux/actions";
import { AAD_LOGIN_SUCCESS, LOGIN, ACQUIRED_TOKEN, AAD_REDIRECT_END } from "./actions";
import { AuthenticationResult } from "@azure/msal-browser";
import { userSelector } from "../../common/redux/selectors";
import { UserState } from "../../common/redux/AuthState";

type MaybeUser = UserState | null | undefined;

export function* logout() {
  const account = authProvider.getAllAccounts();
  const endSessionRequest = createEndSessionRequest(account[0]);
  yield call([authProvider, authProvider.logoutRedirect], endSessionRequest);
  yield put({
    type: LOGOUT_SUCCESS,
  });
}

export function* login() {
  // dummy login saga - handled by @azure/msal-react ClientApplication
  yield delay(1);
}

export function* acquireToken() {
  const account = authProvider.getAllAccounts()[0];
  const tokenResp: AuthenticationResult = yield call([authProvider, authProvider.acquireTokenSilent], {
    scopes: [],
    account
  });
  yield put({ type: ACQUIRED_TOKEN, payload: { token: tokenResp.idToken, account: tokenResp.account }});
}

export function* redirectEnd() {
  const user: MaybeUser = yield select(userSelector);
  if (!user || !user.token) {
    console.log("Acquiring token, user or user token is null");
    yield call(acquireToken);
  }
}

export function* rootSaga() {
  yield all([
    takeLatest(LOGOUT, logout),
    takeLatest(LOGIN, login),
    takeLatest(AAD_LOGIN_SUCCESS, acquireToken),
    takeLatest(AAD_REDIRECT_END, redirectEnd),
  ]);
}
